import { useEffect, RefObject } from "react";

export const useObserver = (
  ref: RefObject<HTMLElement | null>,
  callback: ResizeObserverCallback,
) => {
  useEffect(() => {
    if (!ref.current) return;

    const observerRef = ref.current;

    const observer = new ResizeObserver(callback);
    observer.observe(observerRef);

    return () => {
      if (observerRef) {
        observer.unobserve(observerRef);
      }
    };
  }, [ref, callback]);
};
